<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col sm="6">
        <div class="text-center">
          <img src="img/waf_level.png"
            class="text-center"
            style="margin-left: auto; margin-right: auto;width: auto; height:150px;"
          >
        </div>
      </b-col>
      <b-col sm="6">
        <p :style="`${server.level >= 4 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 4はレベルポリシーの1～4までをカバー </p>
        <p :style="`${server.level >= 3 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 3はレベルポリシーの1～3までをカバー </p>
        <p :style="`${server.level >= 2 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 2はレベルポリシーの1～2までをカバー </p>
        <p :style="`${server.level >= 1 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 1はレベルポリシーの1をカバー </p>
        <hr>
        <p>
          レベルを上げるとより深く攻撃を検出できます。
        </p>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="2">デフォルトで設定 <br><small>クリックで変更</small></b-col>
      <b-col sm="3" style="cursor: pointer;" @click="server.level = server.level < 4 ? server.level + 1 : 1">
        <strong style="cursor: pointer;">ポリシーのセキュリティレベル</strong>
        <small style="cursor: pointer;">( Level : {{server.level}} )</small>
      </b-col>
      <b-col sm="3" style="cursor: pointer;">
        <b-form-radio-group @change="update($event, 'level')" style="cursor: pointer;" id="ph_level" v-model="server.level" :options="codes.WAF_LEVEL"></b-form-radio-group>
      </b-col>
      <b-col sm="3" class="text-center" style="cursor: pointer;">
        <strong @click="change">ファイアウォールモード :
          <b-badge style="cursor: pointer;" v-if="server.mode == 0" variant="secondary">Off</b-badge>
          <b-badge style="cursor: pointer;" v-if="server.mode == 1" variant="warning">検出のみ</b-badge>
          <b-badge style="cursor: pointer;" v-if="server.mode == 2" variant="danger">ブロック</b-badge>
        </strong>
        <!-- <b-form-radio-group id="ph_mode" v-model="server.mode" :options="codes.WAF_MODE"> </b-form-radio-group> -->
      </b-col>
      <b-col sm="2"></b-col>
      <!-- <b-col md="3">
        <div class="pull-right">
          <b-button size="sm" variant="success" @click="rule_confirm = true">適用</b-button>
          <b-button size="sm" variant="warning" @click="apply_modal = true">他のサーバーに適用</b-button>
        </div>
      </b-col> -->
    </b-row>
    <hr>
    <b-row class="text-left">
      <b-col>
        <b-form-group>
          <h5>
            <b-badge variant="success">お知らせ</b-badge>
            <small> <strong>
              即時レベルを高く設定した場合、サービス上の問題が発生する可能性があります。長期計画でファイアウォールレベル4の設定することを推奨します。
            </strong></small>
            <hr>
            <small> <strong> * Off : 現在選択されているドメインのWEBCastle機能を無効化します </strong></small><br>
            <small> <strong> * <b-badge variant="warning">検出のみ</b-badge> : 起動中のみ検出します </strong></small><br>
            <small> <strong> * <b-badge variant="danger">On</b-badge> : 起動中のブロック (初期設定には推奨しません) </strong></small>
          </h5>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
